import { render, staticRenderFns } from "./LKPublicationsFormdataHistoryList.vue?vue&type=template&id=715cd0a3&"
import script from "./LKPublicationsFormdataHistoryList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports